import React, { Component } from "react";
import PropTypes from "prop-types";
import RaisedButton from "material-ui/RaisedButton";
import IconButton from "material-ui/IconButton";
import ContentAdd from "material-ui/svg-icons/content/add";
import ActionSave from "material-ui/svg-icons/content/save";
import ActionCopy from "material-ui/svg-icons/content/content-copy";
import ActionPaste from "material-ui/svg-icons/content/content-paste";
import Paper from "material-ui/Paper";
import { Box } from "rebass";
import { Card, CardHeader, CardText } from "material-ui/Card";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import Toggle from "material-ui/Toggle";
import { BlockCounter, Counter, BackgroundContent } from "./components";

import { DivHeaderActions, DivTitle } from "./styled";

const bgPropertiesDefault = {
  size: "cover",
  position: "center center",
  repeat: "no-repeat"
};
const defaultContentCarousel = {
  type: "ContentCarousel",
  props: {
    values: {
      parent: "Row",
      type: "ContentCarousel",
      className: "col-xs-12",
      column: 1,
      backgroundColorParent: "rgba(255,255,255,0)",
      backgroundColor: "rgba(255,255,255,0)",
      backgroundImage: {
        url: "",
        urlMobile: "",
        desktop: {
          width: 0,
          height: 0
        },
        mobile: {
          width: 0,
          height: 0
        }
      },
      bgProps: {
        size: "cover",
        position: "center",
        repeat: "no-repeat",
        ratio: 1.2
      },
      isBackgroundImage: false,
      padding: "0px",
      width: {
        type: "%",
        contentWidth: 100
      },
      alignment: {
        vertical: "center",
        horizontal: "center"
      }
    }
  },
  children: [],
  childOf: "Row"
};

class RowCarousel extends Component {
  constructor(props) {
    super(props);
    const {
      backgroundColor,
      padding,
      width,
      backgroundImage,
      isBackgroundImage,
      align,
      bgProps,
      carousel
    } = props.data.values;
    const bi = backgroundImage ? backgroundImage : { url: "", urlMobile: "" };
    const alignContent = align ? align : "center";
    const isBGI = isBackgroundImage ? isBackgroundImage : false;
    const bgProperties = bgProps ? bgProps : bgPropertiesDefault;
    const carouselContent = carousel
      ? carousel
      : {
          keyActive: "",
          auto: false,
          direaction: "incremental",
          interval: 3
        };

    this.state = {
      content: props.data.content,
      expanded: true,
      expandedContent: true,
      backgroundColor: backgroundColor,
      containerPadding: padding,
      contentWidth: width.contentWidth,
      type: width.type,
      maxValueWidth: width.type === "px" ? 0 : 100,
      interval: width.type === "px" ? 20 : 1,
      backgroundImage: bi,
      align: alignContent,
      isBackgroundImage: isBGI,
      bgProps: bgProperties,
      itemActiveCarousel: carouselContent.keyActive,
      carousel: carouselContent
    };
    this.onClickPaste = this.onClickPaste.bind(this);
  }

  handleChangeActiveItemCarousel = (event, index, value) => {
    const oldCarousel = this.state.carousel;
    let newCarousel = {
      keyActive: value,
      auto: oldCarousel.auto,
      direaction: oldCarousel.direction,
      interval: oldCarousel.interval
    };
    this.setState({ itemActiveCarousel: value, carousel: newCarousel });
  };

  componentWillMount() {
    const parent = this.props.layoutState.getItemJS(
      this.props.layoutState.selectedItem
    );
    if (parent && parent.children && parent.children.length <= 1) {
      this.setState({
        itemActiveCarousel: parent.children[0]
      });
    }
  }

  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };

  onClickAddContent = () => {
    const parent = this.props.layoutState.getItemJS(
      this.props.layoutState.selectedItem
    );
    this.props.layoutState.insertItem(
      this.props.layoutState.selectedItem,
      parent.children.length,
      defaultContentCarousel
    );
  };
  onClickCopy = () => {
    let newData = this.props.data;
    let width = {
      type: this.state.type,
      contentWidth: this.state.contentWidth
    };
    newData.values.backgroundColor = this.state.backgroundColor;
    newData.values.padding = this.state.containerPadding;
    newData.values.align = this.state.align;
    newData.values.backgroundImage = this.state.backgroundImage;
    newData.values.isBackgroundImage = this.state.isBackgroundImage;
    newData.values.bgProps = this.state.bgProps;
    newData.values.carousel = this.state.carousel;
    newData.values.width = width;
    newData.content = this.state.content;

    localStorage.setItem("RowCarousel", JSON.stringify(newData));
  };
  onClickPaste = () => {
    const row = JSON.parse(localStorage.getItem("RowCarousel"));
    if (row) {
      const { values, content } = row;
      this.setState({
        type: values.width.type,
        contentWidth: values.width.contentWidth,
        backgroundColor: values.backgroundColor,
        containerPadding: values.padding,
        backgroundImage: values.backgroundImage,
        align: values.align,
        isBackgroundImage: values.isBackgroundImage,
        bgProps: values.bgProps,
        content: content,
        carousel: values.carousel
      });
    }
  };
  onClickSave = () => {
    let newData = this.props.data;

    let width = {
      type: this.state.type,
      contentWidth: this.state.contentWidth
    };
    newData.values.backgroundColor = this.state.backgroundColor;
    newData.values.padding = this.state.containerPadding;
    newData.values.align = this.state.align;
    newData.values.backgroundImage = this.state.backgroundImage;
    newData.values.isBackgroundImage = this.state.isBackgroundImage;
    newData.values.bgProps = this.state.bgProps;
    newData.values.width = width;
    newData.values.carousel = this.state.carousel;
    newData.content = this.state.content;

    this.props.onUpdateData(newData);
  };

  onUpdatePadding = padding => {
    this.setState({ containerPadding: padding });
  };
  onSetValue = (key, value) => {
    this.setState({ contentWidth: value });
  };
  onChangeType = (event, value) => {
    let width = 0;
    let content = this.state.contentWidth;
    let interval = 20;
    if (value === "%") {
      width = 100;
      content = 100;
      interval = 1;
    }
    this.setState({
      type: value,
      maxValueWidth: width,
      contentWidth: content,
      interval: interval
    });
  };

  onChangeContentAlign = value => {
    this.setState({
      align: value
    });
  };

  updateBackground = values => {
    const {
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps
    } = values;
    this.setState({
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps
    });
  };

  onToggle = (e, v) => {
    let oldCarousel = this.state.carousel;
    oldCarousel["auto"] = v;
    this.setState({ carousel: oldCarousel });
  };
  onUpdateInterval = value => {
    let oldCarousel = this.state.carousel;
    oldCarousel["interval"] = value;
    this.setState({ carousel: oldCarousel });
  };
  onChangeDirection = (event, value) => {
    let oldCarousel = this.state.carousel;
    oldCarousel["direction"] = value;
    this.setState({ carousel: oldCarousel });
  };
  render() {
    const {
      backgroundColor,
      backgroundImage,
      isBackgroundImage,
      bgProps,
      carousel
    } = this.state;

    const childrenParent = this.props.layoutState.getItemJS(
      this.props.layoutState.selectedItem
    ).children;
    return (
      <div style={{ width: "100%" }}>
        <div style={{ overflowY: "scroll", height: 500 }}>
          <Box w={[1]} p={[1]}>
            <RaisedButton
              onClick={this.onClickAddContent}
              label={"Add Item Carousel"}
              labelPosition={"after"}
              primary={true}
              icon={<ContentAdd />}
            />
          </Box>
          <Box w={[1]} py={[1]} px={[2]}>
            <SelectField
              floatingLabelText="Edit Content Active"
              value={this.state.itemActiveCarousel}
              onChange={this.handleChangeActiveItemCarousel}
            >
              {childrenParent.map((item, index) => {
                return (
                  <MenuItem
                    key={index}
                    value={item}
                    primaryText={`Item Content ${index + 1} `}
                  />
                );
              })}
            </SelectField>
          </Box>
          <div style={styles.paperCard}>
            <Card
              expanded={this.state.expanded}
              onExpandChange={this.handleExpandChange}
            >
              <CardHeader
                title="Properties of Row Carousel"
                actAsExpander={true}
                showExpandableButton={true}
                style={styles.headerCard}
              />
              <CardText expandable={true}>
                <Paper style={styles.paperText} zDepth={1}>
                  <DivTitle>Container Padding</DivTitle>
                  <BlockCounter
                    containerPadding={this.state.containerPadding}
                    onUpdatePadding={containerPadding =>
                      this.onUpdatePadding(containerPadding)
                    }
                  />
                </Paper>
                <Paper style={styles.paperText} zDepth={1}>
                  <DivTitle>Container Width</DivTitle>
                  <RadioButtonGroup
                    name="type"
                    valueSelected={this.state.type}
                    onChange={this.onChangeType}
                    style={styles.radioGroup}
                  >
                    <RadioButton
                      value="%"
                      label="Percent"
                      style={styles.radioButton}
                    />
                    <RadioButton
                      value="px"
                      label="Pixel"
                      style={styles.radioButton}
                    />
                  </RadioButtonGroup>
                  <Counter
                    isDisabled={false}
                    onSetValue={value => this.onSetValue("Width", value)}
                    value={this.state.contentWidth}
                    interval={this.state.interval}
                    maxValue={this.state.maxValueWidth}
                  />
                </Paper>
                <Paper style={styles.paperText} zDepth={1}>
                  <DivTitle>Properties</DivTitle>
                  <RadioButtonGroup
                    name="direction"
                    valueSelected={carousel.direction}
                    onChange={this.onChangeDirection}
                    style={styles.radioGroup}
                  >
                    <RadioButton
                      value="incremental"
                      label="Incremental"
                      style={styles.radioButton}
                    />
                    <RadioButton
                      value="decremental"
                      label="Decremental"
                      style={styles.radioButton}
                    />
                  </RadioButtonGroup>
                  <Toggle
                    label="Auto Play"
                    style={{ marginBottom: 10, marginTop: 10, width: 180 }}
                    toggled={carousel.auto}
                    onToggle={(e, v) => this.onToggle(e, v)}
                  />
                  <Counter
                    isDisabled={false}
                    title="Interval"
                    onSetValue={value => this.onUpdateInterval(value)}
                    value={carousel.interval}
                    interval={1}
                    subtitle="second"
                    minValue={0}
                  />
                </Paper>
                <BackgroundContent
                  backgroundColor={backgroundColor}
                  backgroundImage={backgroundImage}
                  isBackgroundImage={isBackgroundImage}
                  bgProps={bgProps}
                  updateBackground={this.updateBackground.bind(this)}
                />
              </CardText>
            </Card>
          </div>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  radioButton: {
    width: 100
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto",
    marginBottom: 10
  }
};

RowCarousel.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired
};

RowCarousel.defaultProps = {
  data: {}
};
export default RowCarousel;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/RowCarousel.js